
  export default {
    props: {
      address: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      async deleteAddress() {
        try {
          await this.$api.deleteAddress(this.address.id)
          // Update user
          const user = JSON.parse(JSON.stringify(this.$store.state.user))
          if (user) {
            this.$store.commit('setUser', user)
          }
          this.closeModal()
        } catch (error) {
          console.error(error)
        }
      },
      closeModal() {
        this.$emit('closeModal')
      }
    }
  }
